import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../shared/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { RedirectService } from '../../shared/services/redirect.service';
import { REDCRSS_EVENTS } from '../../shared/services/constants/redcross_evemts';
import { ToastService } from '../../shared/services/toastr.service';
import { LogService } from '../../shared/services/log.service';
import { Store } from '@ngrx/store';
import { SignupState } from '../signup_state';
import { PasswordUpdaterBaseComponent } from '../shared/change_password/password_updater_base.component';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';
import { StorageService } from '../../install/shared/services/storage.service';

@Component({
  selector: 'yi-activate',
  template: require('./activate.component.html'),
  styles: [require('./activate.component.scss')]
})

export class ActivateComponent extends PasswordUpdaterBaseComponent implements OnInit {

  saveBtnText: string;
  protected eventName: string;

  // @ts-ignore
  constructor(
    protected translateService: TranslateService,
    protected userService: UserService,
    protected route: ActivatedRoute,
    protected toastr: ToastService,
    protected redirectService: RedirectService,
    protected redCrossService: AnalyticsTrackingProvider,
    protected logger: LogService,
    protected authService: AuthService,
    protected store: Store<SignupState>,
    protected storageService: StorageService
  ) {
    super(toastr, redirectService, translateService, route, authService, logger, store, userService, redCrossService, storageService);
    this.saveBtnText = 'SIGNUP.ACTIVATE.ACTIVATE_ACCOUNT_BTN';
    this.eventName = REDCRSS_EVENTS.USER_ACTIVATED;
  }

  ngOnInit() {
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, {
      pageCategory: 'Account Activation',
      path: window.location.origin,
      url: window.location.href,
      appKey: this.route.snapshot.queryParams['app_key'],
      title: this.translateService.instant('SIGNUP.ACTIVATE.ACTIVATE_ACCOUNT')
    });
  }
}
